import { render, staticRenderFns } from "./prescriptionInput.vue?vue&type=template&id=4c8f8421&scoped=true"
import script from "./prescriptionInput.vue?vue&type=script&lang=js"
export * from "./prescriptionInput.vue?vue&type=script&lang=js"
import style0 from "./prescriptionInput.vue?vue&type=style&index=0&id=4c8f8421&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.31_cache-loader@4.1.0_webpack@4.47.0__css-load_96f0868f9f114531bdcfa48c322cb453/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8f8421",
  null
  
)

export default component.exports